import * as React from 'react';
import { StyleSheet } from 'aphrodite/no-important';
import { TypographySize } from 'mm-theme-configuration/dist/consts';
import { Span, semanticCSS } from '../../../../../typography/semanticTags';
import { TriangleIcon } from '../TriangleIcon';
import { getStyleBySize } from '../../../../../typography/semanticTags/semanticTags.utils';
import { useTheme } from '../../../../../theming/useTheme';
import { Directions } from '../ChevronIcon';
import { getLinkColorsStyle } from './linkStyle.utils';
import { RegisterLinkWithSubMenu } from './linkWithSubHeader.utils';

interface LinkWithSubMenuProps {
  title: string;
  hoverStateColor: string;
  activeStateColor: string;
  idleColor: string;
  currentLinkColor: string;
  index: number;
  linkDropdownIconColor: string;
  linkFontSizeLarge: TypographySize;
  linkFontSizeMedium: TypographySize;
  linkFontSizeSmall: TypographySize;
  isInvisibleLink?: boolean;
  isOpen?: boolean;
  registerLinkWithSubMenu?: RegisterLinkWithSubMenu;
  toggleMenu?: (element: HTMLElement, index: number) => void;
}

const getStyles = (isInvisibleLink: boolean) => StyleSheet.create({
  span: {
    visibility: isInvisibleLink ? 'hidden' : 'visible',
    whiteSpace: 'nowrap',
    position: 'relative',
    cursor: 'pointer',
  },
  menu: {
    position: 'absolute',
  },
});

export const LinkWithSubMenu: React.FunctionComponent<LinkWithSubMenuProps> = props => {
  const { title, hoverStateColor, idleColor, index, linkDropdownIconColor, linkFontSizeLarge, linkFontSizeMedium, linkFontSizeSmall, isInvisibleLink = false, isOpen = false, currentLinkColor, activeStateColor, registerLinkWithSubMenu, toggleMenu } = props;
  const [isHovering, setIsHovering] = React.useState(false);
  const { fontSizesStyles } = useTheme();
  const styles = getStyles(isInvisibleLink);
  const linkRef = React.useRef<HTMLSpanElement>(null);
  const fontStyle = getStyleBySize(fontSizesStyles, { fontSizeSmall: linkFontSizeSmall, fontSizeMedium: linkFontSizeMedium, fontSizeLarge: linkFontSizeLarge });
  const linkColorsStyle = getLinkColorsStyle(activeStateColor, hoverStateColor, idleColor, currentLinkColor, false);

  React.useEffect(() => {
    if (typeof registerLinkWithSubMenu === 'function') {
      registerLinkWithSubMenu(linkRef, index);
    }
  }, [registerLinkWithSubMenu, index]);

  const onHover = () => {
    setIsHovering(true);
  };

  const onLeave = () => {
    setIsHovering(false);
  };

  const onClick = () => {
    if (linkRef.current !== null && typeof toggleMenu === 'function') {
      toggleMenu(linkRef.current, index);
    }
  };

  const triangleDirection = isOpen ? Directions.UP : Directions.DOWN;

  return (
    <React.Fragment>
      <Span styles={semanticCSS(fontStyle, styles.span, linkColorsStyle.link)} onMouseEnter={onHover} onMouseLeave={onLeave} onClick={onClick} reference={linkRef}>
        {title}
        <TriangleIcon hoverColor={hoverStateColor} color={linkDropdownIconColor} isHovering={isHovering} direction={triangleDirection} />
      </Span>
    </React.Fragment>
  );
};
